export default {
  position: {
    notes: 'Position for a transceiver',
    message: 'Position',
    values: {
      TRL: {
        notes: 'Transceiver position TRL',
        message: 'Left transceiver',
      },
      TRC: {
        notes: 'Transceiver position TRC',
        message: 'Center transceiver',
      },
      TRR: {
        notes: 'Transceiver position TRR',
        message: 'Right transceiver',
      },
    },
  },
  model: {
    notes: 'Model for a transceiver',
    message: 'Model',
    values: {
      BG01960618: {
        notes: 'Transceiver model BG01960618',
        message: 'BG01960618',
      },
    },
  },
  macAddress: {
    notes: 'Mac address for a transceiver',
    message: 'Mac address',
  },
};
